<template>
  <div class="takt-time-container">
    <TransitionAccordion>
      <div v-if="!is_collapsed" class="takt-time-expanded">
        <ModularEquation
          :description="equations[0].description"
          :description_suffix="equations[0].description_suffix"
          :elements="equations[0].elements"
          :background_color="background_color"
          :foreground_color="foreground_color"
          @changeManpower="$emit(`changeManpower${equations[0].id.replace(/\s/g, '')}`, $event)"
          @changeDuration="$emit(`changeDuration${equations[0].id.replace(/\s/g, '')}`, $event)"
          @changeWORKpackage="$emit(`changeWORKpackage${equations[0].id.replace(/\s/g, '')}`, $event)"
          />
        <TimeRecordTaktTime
          class="mb-2"
          :time_squares="time_squares"
          :selected_day="selected_day"
          :background_color="background_color"
          :foreground_color="foreground_color"
          :items_per_row="items_per_row"
          @clickDay="$emit('clickDay', $event)"
        />
        <template v-for="(equation, index) in equations">
          <ModularEquation
            v-if="index !== 0"
            :key="`${equation.id}${index}`"
            :description="equation.description"
            :description_suffix="equation.description_suffix"
            :elements="equation.elements"
            :background_color="background_color"
            :foreground_color="foreground_color"
            @changeManpower="$emit(`changeManpower${equation.id.replace(/\s/g, '')}`, $event)"
            @changeDuration="$emit(`changeDuration${equation.id.replace(/\s/g, '')}`, $event)"
            @changeWORKpackage="$emit(`changeWORKpackage${equation.id.replace(/\s/g, '')}`, $event)"
            @clickSourceButton="$emit(`clickSourceButton${equation.id.replace(/\s/g, '')}`, $event)"
            />
        </template>
      </div>
    </TransitionAccordion>
    <TransitionAccordion>
      <div v-if="is_collapsed" class="takt-time-collapsed">
        <ModularEquation
          v-for="(equation, index) in collapsed_equations"
          :key="`${equation.id}${index}`"
          :description="equation.description"
          :description_suffix="equation.description_suffix"
          :elements="equation.elements"
          :background_color="background_color"
          :foreground_color="foreground_color"
          @changeManpower="$emit(`changeManpower${equation.id.replace(/\s/g, '')}`, $event)"
          @changeDuration="$emit(`changeDuration${equation.id.replace(/\s/g, '')}`, $event)"
        />
      </div>
    </TransitionAccordion>
  </div>
</template>

<script>
// TODO: set dynamic width var in store
import ModularEquation from '@/modules/WorkPackageWIP/ModularEquation.module.vue';
import TimeRecordTaktTime from '@/modules/WorkPackageWIP/TimeRecordTaktTime.module.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

  export default {
    components: {
      ModularEquation,
      TimeRecordTaktTime,
      TransitionAccordion,
    },

    props: [
      'equations', // is array of objects, contains description (string), elements (array of objects) and is_active (array of booleans) - show this when expanded
      'time_squares', // is array of objects, contains description (string), is_badge, is_disabled and is_invisible (boolean)
      'selected_day',
      'is_collapsed', // is boolean, toggles expanded/collapsed state
      'collapsed_equations', // is array of objects, contains equations as in 'equations' - show this when collapsed
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'items_per_row'
    ],

    data: () => ({

    }),

    methods: {
      log(string) {
        console.log(`${string} got selected!`);
      }
    },
  }
</script>

<style>
  .takt-time-container {
    padding-bottom: 5px;
  }
  /* .takt-time-collapsed {
    display: flex;
    flex-direction: row;
    grid-gap: 8px;
    width: 100%;
  } */
</style>
